import { Building2, Handshake, Rocket, Sprout, Zap } from "lucide-react";

/**
 * I piani come li presenta la dashboard: chiavi speciali, il piano da
 * consigliare e per chi e' ognuno. Li usano la pagina Abbonamento e la fine
 * dell'onboarding, cosi' dicono la stessa cosa.
 */

export const GRATUITO = "plan_basic";
export const SU_MISURA = "plan_custom";

// Gli unici piani che il cliente sceglie e paga da solo. Tutti gli altri
// (plan_custom, plan_custom_400...) si vendono fuori dalla dashboard: li
// attiva un admin. La stessa lista, lato server, e' in
// apps/api/src/services/pianiAcquistabili.js.
export const PIANI_SELF_SERVICE = ["plan_basic", "plan_lite", "plan_plus", "plan_max"];
export const selfService = (chiave) => PIANI_SELF_SERVICE.includes(chiave);

// Il piano messo in evidenza: da confermare con Gianluca.
export const CONSIGLIATO = "plan_plus";

// Per chi e' ogni piano: le descrizioni nel database sono segnaposto in inglese.
export const PER_CHI = {
  plan_basic: "Per provare l'assistente sul tuo sito, senza carta.",
  plan_lite: "Per un sito piccolo che riceve qualche domanda al giorno.",
  plan_plus: "Per un'attività che riceve domande ogni giorno.",
  plan_max: "Per chi ha più siti o un catalogo grande.",
  plan_custom: "Limiti e funzioni decisi insieme, per chi ha esigenze particolari.",
};

// Il tocco di colore di ogni piano, come le schede delle app: la tessera con
// l'icona sul gradiente e l'alone in alto a destra (tint di TINTS in
// components/integrations/brand.jsx). Il viola resta al piano consigliato.
const ASPETTO = {
  plan_basic: { tint: "slate", icon: Sprout },
  plan_lite: { tint: "sky", icon: Zap },
  plan_plus: { tint: "violet", icon: Rocket },
  plan_max: { tint: "orange", icon: Building2 },
};
// I piani su misura (plan_custom, plan_custom_400...).
const ASPETTO_SU_MISURA = { tint: "amber", icon: Handshake };
export const aspettoPiano = (chiave) => ASPETTO[chiave] || ASPETTO_SU_MISURA;

/** Un numero come lo scrive un italiano: 1000, 10.000, 12,50 (sotto le 10.000 niente punto). */
export const euro = (n) => Number(n || 0).toLocaleString("it-IT", { maximumFractionDigits: 2 });

/** Il prezzo annuale diviso per dodici, arrotondato ai centesimi. */
export const alMese = (annuale) => Math.round(((Number(annuale) || 0) / 12) * 100) / 100;
